<script lang="ts">
  import { Accordion } from 'bits-ui';

  import type { TeoHelpContent } from '@/teoCore/TeoHelp';
  import { Icon } from '@/ui/base';
  import MarkdownText from '@/ui/elements/markdown/MarkdownText.svelte';

  let { content }: { content: TeoHelpContent } = $props();
</script>

<Accordion.Item value={content.id} class="border-b border-b-c-divider pb-4 pt-3">
  <Accordion.Header
    class="text-sm first:border-t-0 hover:font-semibold data-[state=open]:font-semibold"
  >
    <Accordion.Trigger
      class="flex w-full flex-row items-center justify-between [&[data-state=open]>svg]:rotate-180"
      ><p>{content.title}</p>
      <Icon icon="KeyboardArrowDown" class="text-c-link  transition-transform duration-300" />
    </Accordion.Trigger>
  </Accordion.Header>
  <Accordion.Content class="pt-4">
    <div class="rounded-sm bg-info p-3">
      <MarkdownText markdown={content.content} />
    </div>
  </Accordion.Content>
</Accordion.Item>
